<template>
  <v-container fluid class="pl-2 pr-2 pl-md-0 pr-md-0 pt-md-0">
      <v-tooltip max-width='350' left>
          <template v-slot:activator="{ on }">
            <div class="print-btn-wrapper" v-on="on" >
              <v-dialog class="print-hide" v-model="printDialog" hide-overlay max-width="380">
                <template v-slot:activator="on">
                  <v-icon
                  @click.prevent="processDialog()"
                  v-on="on"
                  class="print-hide mobile-hide print-btn-icode"
                  aria-hidden="true">
                  mdi-printer
                  </v-icon>
                </template>
                <v-card class="print-hide" >
                  <v-card-title class="headline">Print Information</v-card-title>
                  <v-card-text>
                    For best results, please set printed page layout to <strong>Landscape</strong> and page size to <strong>Tabloid</strong> (if available) or <strong>11x17 inches</strong>. Page size options will vary depending on browser.
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="error" text @click="printDialog = false">Cancel</v-btn>
                    <v-btn color="#0B5940" text @click="nativeDownload()">Print</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </div>
          </template>
          <span class="print-hide" ><strong>Print This Page.</strong></span>
        </v-tooltip>
      <v-flex xs12 class="d-none d-sm-inline body-2 print-hide">
        <!-- Use the search field below to view the adoptions associated with state, county, jurisdiction or township -->
      </v-flex>
      <v-flex xs12 class="text-xs-center mt-4 print-hide">
        <p class="body-2">
          For <span class="font-weight-medium">I-Codes adoption</span>,
          click an I-Code abbreviation to see where each code has been adopted.
        </p>
      </v-flex>
      <v-card>
      <v-tabs
      show-arrows
      class="mb-2 tab-selected-map print-hide"
      id="icodeTab"
      >
      <v-tab :to="{ name: 'ICodeMap', params: { icode: 'IBC' } }" class="demo">IBC</v-tab>
      <span class="pipe-code-map">|</span>
      <v-tab :to="{ name: 'ICodeMap', params: { icode: 'IRC' } }" >IRC</v-tab>
      <span class="pipe-code-map">|</span>
      <v-tab :to="{ name: 'ICodeMap', params: { icode: 'IEBC' } }" >IEBC</v-tab>
      <span class="pipe-code-map">|</span>
      <v-tab :to="{ name: 'ICodeMap', params: { icode: 'IPMC' } }" >IPMC</v-tab>
      <span class="pipe-code-map">|</span>
      <v-tab :to="{ name: 'ICodeMap', params: { icode: 'ICCPC' } }" >ICCPC</v-tab>
      <span class="pipe-code-map">|</span>
      <v-tab :to="{ name: 'ICodeMap', params: { icode: 'IFC' } }" >IFC</v-tab>
      <span class="pipe-code-map">|</span>
      <v-tab :to="{ name: 'ICodeMap', params: { icode: 'IMC' } }" >IMC</v-tab>
      <span class="pipe-code-map">|</span>
      <v-tab :to="{ name: 'ICodeMap', params: { icode: 'IFGC' } }" >IFGC</v-tab>
      <span class="pipe-code-map">|</span>
      <v-tab :to="{ name: 'ICodeMap', params: { icode: 'IECC' } }" >IECC</v-tab>
      <span class="pipe-code-map">|</span>
      <v-tab :to="{ name: 'ICodeMap', params: { icode: 'IPC' } }" >IPC</v-tab>
      <span class="pipe-code-map">|</span>
      <v-tab :to="{ name: 'ICodeMap', params: { icode: 'IPSDC' } }" >IPSDC</v-tab>
      <span class="pipe-code-map">|</span>
      <v-tab :to="{ name: 'ICodeMap', params: { icode: 'ISPSC' } }" >ISPSC</v-tab>
      <span class="pipe-code-map">|</span>
      <v-tab :to="{ name: 'ICodeMap', params: { icode: 'IgCC' } }" >IgCC</v-tab>
      <span class="pipe-code-map">|</span>
      <v-tab :to="{ name: 'ICodeMap', params: { icode: 'IWUIC' } }" >IWUIC</v-tab>
      <span class="pipe-code-map">|</span>
      <v-tab :to="{ name: 'ICodeMap', params: { icode: 'IZC' } }" >IZC</v-tab>
    </v-tabs>
    </v-card>
    <h3
      id="icode-map-title"
      :style="`color:${getPageTitleColor} !important`"
      class="title mb-1 mt-4 font-weight-medium custom-title-color">
      <span class="text-uppercase" >{{ IcodeStateInfo.title[dynamicParam] }}</span> ({{ $options.filters.formatBookAbrrText(dynamicParam) }}&#174;)
    </h3>
    <h4 class="subtitle-1 mb-2 custom-title-color">ADOPTION MAP</h4>
    <v-flex class="mt-5">
       <v-row no-gutters>
        <v-col class="pr-4" :cols="12" :sm="12" :md="9" :lg="9" :xl="9" >
        <div id="map-wrapper-container">
          <div ref="svg" style="margin: 0 auto;"></div>
        </div>
        </v-col>
        <v-col :cols="12" :sm="12" :md="3" :lg="3" :xl="3" id="icode-map-legends">
          <div :class="iCodeMapRightSection">
            <div v-if="checkEmptyArrCustom(getactualRecords.bookItems)" class="mt-4">
              <h4 class="subtitle-1 mb-2 custom-title-color">MAP KEY</h4>
              <p class="mt-2" >Edition of code currently in effect by state:</p>
            <!-- book name loop starts -->
            <v-flex
            class="flex-row d-flex"
            v-for="(item, key) in getactualRecords.bookItems" :key="key"
            >
            <v-col class="my-2 pa-0" v-if="item.display !== false" >
              <div class="caption" >
                <v-row no-gutters v-if="!item.isMixed && !item.isLocal"
                      class="pa-0 font-weight-bold iCodeMapKeyTitle">
                  <v-col
                    cols="2" lg="2" sm="2" md="2" xl="2"
                    class="pa-0 ma-0"
                    :style="`background-color:${item.color} !important;-webkit-print-color-adjust: exact;color-adjust: exact;`">
                    &nbsp;
                  </v-col>
                  <v-col class="ml-2" >{{item.year}} {{ $options.filters.formatBookAbrrText(item.bookAbbreviation) }}&#174;</v-col>
                </v-row>
                <v-row no-gutters v-else-if="item.isLocal"
                       class="pa-0 font-weight-bold iCodeMapKeyTitle">
                  <v-col
                    cols="2" lg="2" sm="2" md="2" xl="2"
                    class="pa-0 ma-0"
                    :style="`background-color:${item.color} !important;-webkit-print-color-adjust: exact;color-adjust: exact;`">
                    &nbsp;
                  </v-col>
                  <v-col class="ml-2" >Local Adoptions</v-col>
                </v-row>
                <v-row no-gutters v-else
                       class="pa-0 font-weight-bold iCodeMapKeyTitle">
                  <v-col
                    cols="2" lg="2" sm="2" md="2" xl="2"
                    class="pa-0 ma-0"
                    :style="`background-color:${item.color} !important;-webkit-print-color-adjust: exact;color-adjust: exact;`">
                    &nbsp;
                  </v-col>
                  <v-col class="ml-2">Mixed Code Year</v-col>
                </v-row>
              </div>
            </v-col>
            </v-flex>
            <v-flex class="flex-row d-flex">
              <v-col class="my-2 pa-0" >
                <div class="caption">
                  <v-row no-gutters
                         class="pa-0 font-weight-bold iCodeMapKeyTitle">
                    <v-col
                      cols="2" lg="2" sm="2" md="2" xl="2"
                      class="pa-0 ma-0"
                      style="background-color: #999999;-webkit-print-color-adjust: exact;color-adjust: exact;">
                      &nbsp;
                    </v-col>
                    <v-col class="ml-2" >No state-wide {{ $options.filters.formatBookAbrrText(dynamicParam) }} adoption</v-col>
                  </v-row>
                </div>
              </v-col>
            </v-flex>
            <!-- book name loop ends -->
          </div>
          <div v-else class="mt-4 subtitle-1">
          No adoptions found for <span style="text-transform: capitalize">{{ IcodeStateInfo.title[dynamicParam] }}</span>
          </div>
          <p v-if="IcodeStateInfo.info[dynamicParam]" class="font-italic mt-2" >
          <span v-html="$options.filters.replaceStateCount(IcodeStateInfo.info[dynamicParam], getNumberOfState)" />
          </p>
        </div>
        </v-col>
      </v-row>
    </v-flex>
    <div class="mt-4" id="disclaimer-text">
      <p class="disclaimer-text" v-html="DISCLAIMER_TEXT"></p>
    </div>
    <v-overlay :value="dataLoader">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
</v-container>
</template>
<script>

// import Map from './Map'
import IcodeStateInfo from '../../../config/icodestateinfo'
// import IcodeStateColor from '../../../config/icodestatecolors'
import * as Datamap from 'datamaps'
import d3 from 'd3'
import CONSTANTS from '../../../config/constant'
import * as Cookies from 'js.cookie'

var epsilon = 0.000001

function geoAlbersUsaPr () {
  var cache
  var cacheStream
  var lower48 = d3.geo.albers(); var lower48Point
  var alaska = d3.geo.conicEqualArea().rotate([154, 0]).center([-2, 58.5]).parallels([55, 65])
  var alaskaPoint
  var hawaii = d3.geo.conicEqualArea().rotate([157, 0]).center([-3, 19.9]).parallels([8, 18])
  var hawaiiPoint
  var puertoRico = d3.geo.conicEqualArea().rotate([66, 0]).center([0, 18]).parallels([8, 18])
  var puertoRicoPoint
  var virginIslands = d3.geo.conicEqualArea().rotate([66, 0]).center([0, 18]).parallels([8, 18])
  var virginIslandsPoint
  var guamMariana = d3.geo.conicEqualArea().rotate([-145, 0]).center([0, 16]).parallels([10, 20])
  var guamMarianaPoint

  var mariana = d3.geo.conicEqualArea().rotate([-145, 0]).center([0, 16]).parallels([10, 20])
  var marianaPoint

  var americanSamoa = d3.geo.conicEqualArea().rotate([170, 0]).center([0, -14]).parallels([-14, 0])
  var americanSamoaPoint
  var point
  var pointStream = { point: function (x, y) { point = [x, y] } }

  function albersUsa (coordinates) {
    var x = coordinates[0]; var y = coordinates[1]
    point = (null,
    (lower48Point.point(x, y), point) ||
    (alaskaPoint.point(x, y), point) ||
    (hawaiiPoint.point(x, y), point) ||
    (puertoRicoPoint.point(x, y), point) ||
    (virginIslandsPoint.point(x, y), point) ||
    (guamMarianaPoint.point(x, y), point) ||
    (marianaPoint.point(x, y), point) ||
    (americanSamoaPoint.point(x, y), point))

    return point
  }

  albersUsa.invert = function (coordinates) {
    var k = lower48.scale()
    var t = lower48.translate()
    var x = (coordinates[0] - t[0]) / k
    var y = (coordinates[1] - t[1]) / k
    return (y >= 0.120 && y < 0.234 && x >= -0.425 && x < -0.214 ? alaska
      : y >= 0.166 && y < 0.234 && x >= -0.214 && x < -0.115 ? hawaii
        : y >= 0.204 && y < 0.234 && x >= 0.300 && x < 0.380 ? puertoRico
          : y >= 0.204 && y < 0.234 && x >= 0.300 && x < 0.380 ? virginIslands
            : y >= 0.050 && y < 0.204 && x >= 0.340 && x < 0.380 ? guamMariana
              : y >= 0.050 && y < 0.204 && x >= 0.340 && x < 0.380 ? mariana
                : y >= 0.160 && y < 0.204 && x >= 0.280 && x < 0.340 ? americanSamoa
                  : lower48).invert(coordinates)
  }

  albersUsa.stream = function (stream) {
    cache = cache && cacheStream === stream ? cache : multiplex([lower48.stream(cacheStream = stream), alaska.stream(stream), hawaii.stream(stream), puertoRico.stream(stream), virginIslands.stream(stream), guamMariana.stream(stream), mariana.stream(stream), americanSamoa.stream(stream)])
    return cache
  }

  albersUsa.precision = function (_) {
    if (!arguments.length) return lower48.precision()
    lower48.precision(_)
    alaska.precision(_)
    hawaii.precision(_)
    puertoRico.precision(_)
    virginIslands.precision(_)
    guamMariana.precision(_)
    mariana.precision(_)
    americanSamoa.precision(_)
    return reset()
  }

  albersUsa.scale = function (_) {
    if (!arguments.length) return lower48.scale()
    lower48.scale(_)
    alaska.scale(_ * 0.35)
    hawaii.scale(_)
    puertoRico.scale(_ * 3.5)
    virginIslands.scale(_ * 7.5)
    guamMariana.scale(_ * 6.0)
    mariana.scale(_ * 8.0)
    americanSamoa.scale(_ * 8.0)
    return albersUsa.translate(lower48.translate())
  }

  albersUsa.translate = function (_) {
    if (!arguments.length) return lower48.translate()
    var k = lower48.scale(); var x = +_[0]; var y = +_[1]

    lower48Point = lower48
      .translate(_)
      .clipExtent([[x - 0.455 * k, y - 0.238 * k], [x + 0.455 * k, y + 0.238 * k]])
      .stream(pointStream)

    alaskaPoint = alaska
      .translate(
        [
          x - 0.310 * k,
          y + 0.201 * k
        ]
      )
      .clipExtent(
        [
          [
            x - 0.425 * k + epsilon,
            y + 0.120 * k + epsilon
          ],
          [
            x - 0.214 * k - epsilon,
            y + 0.234 * k - epsilon
          ]
        ]
      )
      .stream(pointStream)

    hawaiiPoint = hawaii
      .translate(
        [
          x - 0.205 * k,
          y + 0.212 * k
        ]
      )
      .clipExtent(
        [
          [
            x - 0.214 * k + epsilon,
            y + 0.166 * k + epsilon
          ],
          [
            x - 0.115 * k - epsilon,
            y + 0.234 * k - epsilon
          ]
        ]
      )
      .stream(pointStream)

    puertoRicoPoint = puertoRico
      .translate(
        [
          x - 0.250 * k, /* move left to right */
          y + 0.330 * k /* move up and down */
        ]
      )
      .clipExtent([
        [
          x - 0.410 * k, /* width left to right -> */
          y + 0.000 * k /* width top to bottom */
        ],
        [
          x - 0.200 * k, /* width right to left <- */
          y + 0.354 * k /* width bottom to top */
        ]
      ])
      .stream(pointStream).point

    virginIslandsPoint = virginIslands
      .translate(
        [
          x - 0.250 * k,
          y + 0.314 * k
        ]
      )
      .clipExtent(
        [
          [
            x - 0.150 * k,
            y + 0.054 * k
          ],
          [
            x + 0.400 * k,
            y + 0.354 * k
          ]
        ]
      )
      .stream(pointStream).point

    guamMarianaPoint = guamMariana
      .translate(
        [
          x + 0.035 * k,
          y + 0.040 * k
        ]
      )
      .clipExtent(
        [
          [
            x - 0.240 * k,
            y + 0.250 * k
          ],
          [
            x + 0.300 * k,
            y + 0.334 * k
          ]
        ]
      )
      .stream(pointStream).point

    marianaPoint = mariana
      .translate(
        [
          x + 0.050 * k,
          y + 0.190 * k
        ]
      )
      .clipExtent(
        [
          [
            x + 0.050 * k,
            y + 0.160 * k
          ],
          [
            x + 0.350 * k,
            y + 0.400 * k
          ]
        ]
      )
      .stream(pointStream).point

    americanSamoaPoint = americanSamoa
      .translate(
        [
          x + 0.350 * k,
          y + 0.260 * k
        ]
      )
      .clipExtent(
        [
          [
            x - 0.500 * k,
            y + 0.150 * k
          ],
          [
            x + 0.500 * k,
            y + 0.314 * k
          ]
        ]
      )
      .stream(pointStream).point

    return reset()
  }

  function reset () {
    cache = cacheStream = null
    return albersUsa
  }
  function multiplex (streams) {
    return {
      point (x, y) { for (const s of streams) s.point(x, y) },
      sphere () { for (const s of streams) s.sphere() },
      lineStart () { for (const s of streams) s.lineStart() },
      lineEnd () { for (const s of streams) s.lineEnd() },
      polygonStart () { for (const s of streams) s.polygonStart() },
      polygonEnd () { for (const s of streams) s.polygonEnd() }
    }
  }
  return albersUsa.scale(1070)
}

export default {
  name: 'ICodeMap',
  data: () => ({
    dynamicParam: '',
    icodeList: [],
    dataLoader: true,
    state: '',
    county: '',
    juridiction: '',
    mapType: 'Country',
    locationName: '',
    map_loaded: false,
    locations: [],
    IcodeStateInfo: IcodeStateInfo,
    // IcodeStateColor: IcodeStateColor,
    bookItems: [],
    DISCLAIMER_TEXT: CONSTANTS.DISCLAIMER_TEXT_ICODE,
    numberOfStates: 0,
    printDialog: false,
    dynamicColorValueObject: {},
    MAP_STATIC_COLOR: CONSTANTS.MAP_STATIC_COLOR,
    pageTitleColor: '#666666'
  }),
  watch: {
    '$route.params.icode': function () {
      this.setIcodeIdByParam()
    }
  },
  filters: {
    replaceStateCount: function (value, count) {
      if (!value) return ''
      return value.replace('{$$}', count)
    },
    // just to preserve text format for IgCC
    formatBookAbrrText: function (icode) {
      if (icode.toLowerCase() === 'igcc') {
        return 'IgCC'
      } else {
        return icode
      }
    }
  },
  created: function () {
    this.setIcodeIdByParam()
  },
  mounted () {
    this.getAllColorCodes()
    this.$globalFromValidation.forceTabActive(this.$route.name)
    this.drawMap()
  },
  computed: {
    getactualRecords: function () {
      return this.icodeList
    },
    getNumberOfState () {
      return this.numberOfStates
    },
    iCodeMapRightSection () {
      return (this.$vuetify.breakpoint.width <= 960) ? '' : 'pl-5 borderLeft999'
    },
    getPageTitleColor () {
      return this.pageTitleColor
    }
  },
  methods: {
    getAllColorCodes () {
      new Promise((resolve, reject) => {
        this.$store.dispatch('ICodeColorModule/getPublicICodeColorList', {
          resolve,
          reject
        })
      })
        .then(responseData => {
          let newList = responseData.list
          if (newList.length > 0) {
            let dynamicFills = this.formatColorVal(newList)
            this.dataMapObj.options.fills = dynamicFills
            this.dynamicColorValueObject = this.swapObjectKeyVal(dynamicFills)
          }
        })
        .catch(response => {
        })
        .finally(() => {
        })
    },
    nativeDownload () {
      let IfCookiePresent = Cookies.get('ICC_C_A_P_U_F') // check if flag already set
      if (IfCookiePresent !== 1) {
        // set the cookie so that next time we can keep a watch
        const dateVal = new Date()
        dateVal.setTime(dateVal.getTime() + (365 * 24 * 3600 * 1000))
        Cookies.set('ICC_C_A_P_U_F', 1, { expires: dateVal })
      }
      this.printDialog = false
      this.print()
    },
    processDialog () {
      let IfCookiePresent = Cookies.get('ICC_C_A_P_U_F')
      // If cookie is not set show the dialog else call print
      if (IfCookiePresent !== 1) {
        this.printDialog = true
      }
      if (IfCookiePresent === 1) {
        this.nativeDownload()
      }
    },
    checkEmptyArrCustom (inpuArr) {
      let objLen = 0
      try {
        objLen = Object.keys(inpuArr).length
      } catch (e) {
        objLen = 0
      }
      return objLen
    },
    getColorName (colorCode) {
      if (typeof this.dynamicColorValueObject[colorCode] !== 'undefined') {
        return this.dynamicColorValueObject[colorCode]
      } else {
        return 'defaultFill'
      }
    },
    setIcodeIdByParam () {
      this.dynamicParam = this.$route.params.icode
      /* the following logic is write to handle the scenario
        when page is called without any param we would be redirecting it on IBC
        by default we can not add /IBC in link becuase for other params i.e
        /IRC, /IFC, etc menu is not remain active
      */
      if (this.dynamicParam !== undefined) {
        this.getDataByICode()
      } else {
        this.$router.push({ name: 'ICodeMap', params: { icode: 'IBC' } })
      }
    },
    // dispatch an action in below method to fetch data list based on icode
    getDataByICode () {
      this.dataLoader = true
      let icode = this.dynamicParam
      new Promise((resolve, reject) => {
        this.$store.dispatch('AuthModule/fetchFeToken', { resolve, reject })
      }).then((tokenData) => {
        let tokens = tokenData.data
        this.$store.dispatch('AuthModule/setJWTTokens', { tokens }).then(() => {
          new Promise((resolve, reject) => {
            this.$store.dispatch('ICodeModule/getIcodeDetailsList', {
              resolve,
              reject,
              icode
            })
          })
            .then(responseData => {
              this.numberOfStates = 0
              this.icodeList.bookItems = responseData.bookItems
              let updatedMapData = responseData.mapItems
              this.numberOfStates = Object.keys(updatedMapData).length
              const updatedData = Object.values(updatedMapData)
              const obj = {}
              for (let i = 0; i < updatedData.length; i++) {
                obj[updatedData[i]['jurisdictionAbbr']] =
                {
                  'fillKey':
                  this.getColorName(updatedData[i]['color']),
                  'highlightFillColor': this.getColorName(updatedData[i]['color'])
                }
              }
              this.dataMapObj.updateChoropleth(null, { reset: true })
              this.dataMapObj.updateChoropleth(obj)
              this.dataLoader = false
              // get color value of first code book and set this color to page main title(above the map)
              let codebooksList = this.icodeList.bookItems
              let objLen = Object.keys(codebooksList).length
              let dynamicColor = ''
              if (objLen > 0) {
                Object.keys(codebooksList).forEach(key => {
                  if (dynamicColor === '' && codebooksList[key]['display'] === true && codebooksList[key]['isLocal'] === false && codebooksList[key]['isMixed'] === false) {
                    dynamicColor = codebooksList[key]['color']
                  }
                })
              }
              this.pageTitleColor = (dynamicColor !== '') ? dynamicColor : '#666666'
            })
            .catch(() => {
              this.icodeList = []
              this.dataMapObj.updateChoropleth(null, { reset: true })
              this.dataLoader = false
              this.numberOfStates = 0
            })
        }).catch()
      }).catch()
    },
    /**
     * // Map related functions
     */
    drawMap () {
      const container = this.$refs.svg
      container.innerHTML = ''
      // eslint-disable-next-line
      const datamap = new Datamap({
        element: container,
        scope: 'usa',
        geographyConfig: {
          hideAntarctica: false,
          popupTemplate: (geo) =>
            '<div class="hoverinfo">' + geo.properties.name + '</div>',
          popupOnHover: true, // True to show the popup while hovering
          highlightOnHover: true,
          highlightFillColor: this.MAP_STATIC_COLOR.DEFAULT_COLOR_CODE,
          highlightBorderColor: '#FFFFFF'
        },
        setProjection: function (element) {
          var projection = geoAlbersUsaPr()
            .scale(element.offsetWidth)
            .translate([element.offsetWidth / 2, element.offsetHeight / 2])
          var path = d3.geo.path().projection(projection)
          return { path: path, projection: projection }
        },
        responsive: true,
        fills: {
          defaultFill: this.MAP_STATIC_COLOR.DEFAULT_COLOR_CODE,
          adoption: '#525659'
        },
        data: {},
        done: function (datamap) {
          datamap.svg.selectAll('.datamaps-subunit').on('click', function (geography) {
            // window.location = Routing.generate('category_page', { 'category': geography.properties.name });
          })
          window.addEventListener('resize', function () {
            datamap.resize()
          })
        }
      })
      datamap.labels({})
      this.dataMapObj = datamap
    },
    formatColorVal (list) {
      let obj = {
        defaultFill: this.MAP_STATIC_COLOR.DEFAULT_COLOR_CODE,
        adoption: this.MAP_STATIC_COLOR.DEFAULT_MIXED_COLOR_CODE,
        adoption0: this.MAP_STATIC_COLOR.DEFAULT_LOCAL_COLOR_CODE
      }
      let i = 1
      for (const property in list) {
        obj['adoption' + i] = list[property]['icodeColor'].toLowerCase()
        i++
      }
      return obj
    },
    swapObjectKeyVal (json) {
      let ret = {}
      for (let key in json) {
        ret[json[key]] = key
      }
      return ret
    },
    print () {
      // Get HTML to print from element
      const prtHtmlMap = document.getElementById('map-wrapper-container').innerHTML
      const prtHtmlLegends = document.getElementById('icode-map-legends').innerHTML
      var target = document.getElementById('icode-map-title')
      var wrap = document.createElement('div')
      wrap.appendChild(target.cloneNode(true))
      const prtHTMLTitle = wrap.innerHTML
      // Get all stylesheets HTML
      let stylesHtml = ''
      for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
        stylesHtml += node.outerHTML
      }

      // Open the print window
      const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0')

      WinPrint.document.write(`<!DOCTYPE html>
      <html>
        <head>
          ${stylesHtml}
          <style>
            .datamap {
              margin-top: -100px !important;
            }
            .datamap-parent > div {
              padding-bottom: 80% !important;
            }
          </style>
          <title>Adoption Information Solution</title>
        </head>
        <body class="v-application">
        <div class="container pl-2 pr-2 pl-md-0 pr-md-0 pt-0 container--fluid">
          <div class="pl-10 ml-10">
            ${prtHTMLTitle}
            <h4 class="subtitle-1 mb-2 custom-title-color">ADOPTION MAP</h4>
          </div>
          <div class="row no-gutters">
            <div class="pr-4 col-12 datamap-parent" >
              ${prtHtmlMap}
            </div>
            <div class="col-9 pl-10 ml-10" style="margin-top:-100px;">
              ${prtHtmlLegends}
            </div>
          </div>
        </div>
        </body>
      </html>`)

      WinPrint.document.close()
      WinPrint.focus()
      setTimeout(function () { WinPrint.print() }, 500)
      WinPrint.onfocus = function () { setTimeout(function () { WinPrint.close() }, 500) }
    }
  }
}
</script>
